import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BreadcrumbService } from '../services';
import { BreadDik } from '../models/global/class.global';

@Injectable(
  //{
  //providedIn: 'root'
  //}
)

export class AgendaQueovalService {
  public _lstCalendarOwnerId: Array<string> = [];
  public _lstCalendarObjectId: Array<string> = [];
  public _lstCalendarOfficeId: Array<string> = [];
  public _lstCalendarGroupId: Array<string> = [];
  public _calendarGroupMode: string = "";
  public _calendarGroupId: string = "";
  public _calendarOwnerId: string = '';
  public _calendarObjectId: string = '';
  public _calendarOfficeId: string = '';
  public _isPlanning: boolean = false;


  set isPlanning(value: boolean) {
    this._isPlanning = value;
  }
  get isPlanning() {
    return this._isPlanning;
  }

  set SelectedCalendarObjectId(value: string) {
    this._calendarObjectId= value;
  }
  get SelectedCalendarObjectId() {
    return this._calendarObjectId;
  }
  set SelectedCalendarOfficeId(value: string) {
    this._calendarOfficeId = value;
  }
  get SelectedCalendarOfficeId() {
    return this._calendarOfficeId;
  }

  set SelectedCalendarOwnerId(value: string) {
    this._calendarOwnerId = value;
  }
  get SelectedCalendarOwnerId() {
    return this._calendarOwnerId;
  }

  set lstCalendarOwnerId(value:Array<string>){
    this._lstCalendarOwnerId = value;
    if (value.length === 1) {
      this._calendarOwnerId = value[0];
    }
  }
  get lstCalendarOwnerId() {
    return this._lstCalendarOwnerId;
  }

  set lstCalendarObjectId(value: Array<string>) {
    this._lstCalendarObjectId = value;
    if (value.length === 1) {
      this._calendarObjectId = value[0];
    }
  }
  get lstCalendarObjectId() {
    return this._lstCalendarObjectId;
  }

  set lstCalendarOfficeId(value: Array<string>) {
    this._lstCalendarOfficeId = value;
    if (value.length === 1) {
      this._calendarOfficeId = value[0];
    }
  }

  get lstCalendarOfficeId() {
    return this._lstCalendarOfficeId;
  }

  set lstCalendarGroupId(value: Array<string>) {
    this._lstCalendarGroupId = value;
    if (value.length === 1) {
      this._calendarGroupId = value[0];
    }
  }

  get lstCalendarGroupId() {
    return this._lstCalendarGroupId;
  }

  get CalendarGroupMode() {
    return this._calendarGroupMode;
  }

  set CalendarGroupMode(value: string) {
    this._calendarGroupMode = value;
  }

  public StringifiedCalendarDate: string = '';
  get CalendarDate(): NgbDateStruct|null {
    return this.StringifiedCalendarDate !== '' ? JSON.parse(this.StringifiedCalendarDate) : null;
  }

  constructor(private breadcrumbService: BreadcrumbService) { }

  /** @description check from breadcrumb service if we came from Breadcrumb Back()
   * @return boolean
   */
  public IsComingFromABacktrack(): boolean {
    return this.breadcrumbService.Breadcrumb[this.breadcrumbService.Breadcrumb.length - 1].data.params.filter((el: BreadDik) => el.key === 'childFrom').length > 0;
  }
}
